import { useEffect, useRef } from "react";
import { gsap, prefersReducedMotion } from "../../lib/motion";
import "./Counter.css";

/**
 * Scroll-triggered count-up, matching the reference site's fun-fact widget
 * (value / suffix / superscript / label).
 */
export default function Counter({
  value,
  suffix = "",
  sup = "",
  label,
  duration = 2.4,
  className = "",
  tone = "light",
}) {
  const numRef = useRef(null);

  useEffect(() => {
    const node = numRef.current;
    if (!node) return undefined;

    if (prefersReducedMotion()) {
      node.textContent = String(value);
      return undefined;
    }

    const counter = { n: 0 };
    const tween = gsap.to(counter, {
      n: value,
      duration,
      ease: "power2.out",
      onUpdate: () => {
        node.textContent = Math.round(counter.n).toString();
      },
      scrollTrigger: { trigger: node, start: "top 92%", once: true },
    });

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  }, [value, duration]);

  return (
    <div className={`counter counter--${tone} ${className}`}>
      <p className="counter__value">
        <span ref={numRef} aria-hidden="true">
          0
        </span>
        {suffix && <span className="counter__suffix">{suffix}</span>}
        {sup && <sup className="counter__sup">{sup}</sup>}
        <span className="sr-only">{`${value}${suffix}${sup}`}</span>
      </p>
      <p className="counter__label">{label}</p>
    </div>
  );
}
